import { useEffect } from 'react';

export default function useReveal() {
  useEffect(() => {
    // Match every reveal flavour used by the app — `.reveal-up` was
    // missing from the original selector, so elements wrapped in
    // `.reveal-up` (e.g. Active Seniors headline + cards) never got
    // the `in-view` class. Until they happened to be styled visible
    // by default this was silent, but combined with any future hide
    // rule it would produce a permanent blank section. Safer to
    // observe every flavour.
    const SELECTOR = '.reveal, .reveal-up, .reveal-left, .reveal-right, .reveal-scale, .stagger';
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -50px 0px' });
    const observeAll = () => {
      document.querySelectorAll(SELECTOR).forEach((el) => {
        if (!el.classList.contains('in-view')) io.observe(el);
      });
    };
    observeAll();
    // Re-scan once after the route's content settles — covers
    // components that mount asynchronously (Suspense / lazy chunks /
    // late hydration). Single delayed pass, no continuous observer.
    const t = setTimeout(observeAll, 500);
    return () => {
      clearTimeout(t);
      io.disconnect();
    };
  }, []);
}
